<template>
  <div v-b-tooltip.hover :title="tooltip[hook]">
    {{ label[hook] }}
  </div>
</template>

<script>
import Hook from './Hook'
export default {
  extends: Hook
}
</script>

<style lang="scss" scoped>
.action {
  display: inline-block;
  width: 200px;
}
</style>